var _defs, _polyline, _path, _rect, _path2, _path3, _line, _line2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvWithoutCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EV",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        stroke-width: 4px;\n      }\n\n      .st0, .st1, .st2 {\n        stroke: #02222b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st0, .st3 {\n        fill: #02222b;\n      }\n\n      .st1, .st2 {\n        fill: none;\n      }\n\n      .st4 {\n        fill: #047290;\n      }\n\n      .st2 {\n        stroke-width: 2px;\n      }\n\n      .st5 {\n        fill: #fff;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "18.2 88 24.9 88 64.4 88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.9,12h21c4.1,0,7.4,4.1,7.4,9.1v66.9H23.5V21.1c0-5,3.3-9.1,7.4-9.1h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 28,
    y: 18.5,
    width: 26.7,
    height: 22.8,
    rx: 3.6,
    ry: 3.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.8,28v38.7c0,1.6-1.3,2.9-2.9,2.9h-1.4c-1.6,0-2.9-1.3-2.9-2.9v-21.7c0-1.6-1.3-2.8-2.8-2.8h-8.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.1,18.7h9.5s.2,9.3-4.7,9.3-4.7-9.3-4.7-9.3h-.1Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 73.8,
    y1: 13.2,
    x2: 73.8,
    y2: 16.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 80,
    y1: 13.2,
    x2: 80,
    y2: 16.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.3,49.5l-10.5,15.9c-.1.2,0,.5.2.5l10.1-1c.2,0,.3.2.3.3l-4.1,12.6c0,.3.3.4.5.2l13.9-18.6c0-.2,0-.5-.2-.5l-11,1.7c-.2,0-.3-.2-.3-.3l1.5-10.6c0-.3-.3-.4-.5-.2h.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvWithoutCar);
export default __webpack_public_path__ + "static/media/evWithoutCar.094ad1725b55c630369b6c93fe19120d.svg";
export { ForwardRef as ReactComponent };